import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69b2e8ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-69b2e8ae><div class=\"subheader col-6\" data-v-69b2e8ae><h1 class=\"subheader-title\" data-v-69b2e8ae>売上分析</h1></div><div class=\"subheader-block ml-auto demo\" data-v-69b2e8ae><button type=\"button\" class=\"btn btn-success waves-effect waves-themed\" data-v-69b2e8ae><span class=\"fal fa-download mr-1\" data-v-69b2e8ae></span>分析条件を保存 </button></div></div><div class=\"row\" data-v-69b2e8ae><div class=\"col-sm-6 col-xl-3\" data-v-69b2e8ae><div class=\"p-3 bg-primary-300 rounded overflow-hidden position-relative text-white mb-g\" data-v-69b2e8ae><div class=\"\" data-v-69b2e8ae><h3 class=\"display-4 d-block l-h-n m-0 fw-500\" data-v-69b2e8ae> ¥1,000,00,000- <small class=\"m-0 l-h-n\" data-v-69b2e8ae>当期売上実績</small></h3></div><i class=\"fal fa-yen-sign position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1\" style=\"font-size:6rem;\" data-v-69b2e8ae></i></div></div><div class=\"col-sm-6 col-xl-3\" data-v-69b2e8ae><div class=\"p-3 bg-warning-400 rounded overflow-hidden position-relative text-white mb-g\" data-v-69b2e8ae><div class=\"\" data-v-69b2e8ae><h3 class=\"display-4 d-block l-h-n m-0 fw-500\" data-v-69b2e8ae> ¥1,000,00,000- <small class=\"m-0 l-h-n\" data-v-69b2e8ae>当期粗利実績</small></h3></div><i class=\"fal fa-gem position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n4\" style=\"font-size:6rem;\" data-v-69b2e8ae></i></div></div><div class=\"col-sm-6 col-xl-3\" data-v-69b2e8ae><div class=\"p-3 bg-success-200 rounded overflow-hidden position-relative text-white mb-g\" data-v-69b2e8ae><div class=\"\" data-v-69b2e8ae><h3 class=\"display-4 d-block l-h-n m-0 fw-500\" data-v-69b2e8ae> 87.65% <small class=\"m-0 l-h-n\" data-v-69b2e8ae>当期売上目標充足率</small></h3></div><i class=\"fal fa-lightbulb position-absolute pos-right pos-bottom opacity-15 mb-n5 mr-n6\" style=\"font-size:8rem;\" data-v-69b2e8ae></i></div></div><div class=\"col-sm-6 col-xl-3\" data-v-69b2e8ae><div class=\"p-3 bg-info-200 rounded overflow-hidden position-relative text-white mb-g\" data-v-69b2e8ae><div class=\"\" data-v-69b2e8ae><h3 class=\"display-4 d-block l-h-n m-0 fw-500\" data-v-69b2e8ae> 53.65% <small class=\"m-0 l-h-n\" data-v-69b2e8ae>当期期間消化率</small></h3></div><i class=\"fal fa-globe position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n4\" style=\"font-size:6rem;\" data-v-69b2e8ae></i></div></div></div><div class=\"row\" data-v-69b2e8ae><div class=\"col-xl-12\" data-v-69b2e8ae><div id=\"panel-1\" class=\"panel\" data-v-69b2e8ae><div class=\"panel-hdr\" data-v-69b2e8ae><h2 data-v-69b2e8ae>分析条件</h2><div class=\"panel-toolbar\" data-v-69b2e8ae><button class=\"btn btn-panel\" data-action=\"panel-collapse\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Collapse\" data-v-69b2e8ae></button><button class=\"btn btn-panel\" data-action=\"panel-fullscreen\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Fullscreen\" data-v-69b2e8ae></button></div></div><div class=\"panel-container show\" data-v-69b2e8ae><div class=\"panel-content contents\" data-v-69b2e8ae><div class=\"row\" data-v-69b2e8ae><div class=\"col-md-1 contTitle\" data-v-69b2e8ae>期</div><div class=\"col-md-5 contCnt input-daterange input-group p-0 mb-2 mr-md-5\" data-v-69b2e8ae><select id=\"yearSelect\" name=\"year\" class=\"form-control form-control-sm\" style=\"width:60%;height:35px;\" data-v-69b2e8ae><option value=\"2020\" data-v-69b2e8ae>2020</option><option value=\"2021\" data-v-69b2e8ae>2021</option><option value=\"2022\" data-v-69b2e8ae>2022</option><option value=\"2023\" data-v-69b2e8ae>2023</option><option value=\"2024\" selected data-v-69b2e8ae>2024</option><option value=\"2025\" data-v-69b2e8ae>2025</option><option value=\"2026\" data-v-69b2e8ae>2026</option><option value=\"2027\" data-v-69b2e8ae>2027</option><option value=\"2028\" data-v-69b2e8ae>2028</option><option value=\"2029\" data-v-69b2e8ae>2029</option><option value=\"2030\" data-v-69b2e8ae>2030</option></select><input type=\"button\" class=\"btn-primary form-control form-control-sm\" value=\"&lt;&lt;\" data-v-69b2e8ae><input type=\"button\" class=\"btn-primary form-control form-control-sm\" value=\"&gt;&gt;\" data-v-69b2e8ae></div></div><div class=\"row\" data-v-69b2e8ae><div class=\"col-md-12 contCnt text-center\" data-v-69b2e8ae><button type=\"button\" class=\"btn btn-primary waves-effect waves-themed btn-search mx-auto\" data-v-69b2e8ae> 分析開始 </button></div><div class=\"col-md-12 contCnt text-center\" data-v-69b2e8ae><div data-v-69b2e8ae><small data-v-69b2e8ae> 指定条件によって分析には時間がかかる場合があります </small></div></div></div></div></div></div></div></div>", 3)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "売上詳細"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_9 = { class: "panel-container show" }
const _hoisted_10 = { class: "panel-content contents" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-xl-12" }
const _hoisted_13 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "売上先別粗利"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_15 = { class: "panel-container show" }
const _hoisted_16 = { class: "panel-content contents" }
const _hoisted_17 = { class: "panel-content contents border-faded" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-6 border-faded\" style=\"border-bottom:none;border-right:none;border-top:none;\" data-v-69b2e8ae><table class=\"table table-bordered table-hover m-0\" data-v-69b2e8ae><thead class=\"thead-themed\" data-v-69b2e8ae><tr data-v-69b2e8ae><th data-v-69b2e8ae>#</th><th data-v-69b2e8ae>会社名</th><th data-v-69b2e8ae>売上</th><th data-v-69b2e8ae>仕入</th><th data-v-69b2e8ae>粗利</th></tr></thead><tbody data-v-69b2e8ae><tr data-v-69b2e8ae><th scope=\"row\" data-v-69b2e8ae>1</th><td data-v-69b2e8ae>AAAA社</td><td data-v-69b2e8ae>¥19,543,025</td><td data-v-69b2e8ae>¥1,150,236</td><td data-v-69b2e8ae>¥18,392,789</td></tr><tr data-v-69b2e8ae><th scope=\"row\" data-v-69b2e8ae>2</th><td data-v-69b2e8ae>BBBB社</td><td data-v-69b2e8ae>¥11,058,141</td><td data-v-69b2e8ae>¥7,093,778</td><td data-v-69b2e8ae>¥3,964,363</td></tr><tr data-v-69b2e8ae><th scope=\"row\" data-v-69b2e8ae>3</th><td data-v-69b2e8ae>CCCC社</td><td data-v-69b2e8ae>¥11,438,607</td><td data-v-69b2e8ae>¥8,328,647</td><td data-v-69b2e8ae>¥3,109,960</td></tr><tr data-v-69b2e8ae><th scope=\"row\" data-v-69b2e8ae>4</th><td data-v-69b2e8ae>DDDD社</td><td data-v-69b2e8ae>¥13,154,883</td><td data-v-69b2e8ae>¥3,963,972</td><td data-v-69b2e8ae>¥9,190,911</td></tr><tr data-v-69b2e8ae><th scope=\"row\" data-v-69b2e8ae>5</th><td data-v-69b2e8ae>EEEE社</td><td data-v-69b2e8ae>¥12,914,453</td><td data-v-69b2e8ae>¥1,067,714</td><td data-v-69b2e8ae>¥11,846,739</td></tr><tr data-v-69b2e8ae><th scope=\"row\" data-v-69b2e8ae>6</th><td data-v-69b2e8ae>FFFF社</td><td data-v-69b2e8ae>¥15,802,850</td><td data-v-69b2e8ae>¥5,434,556</td><td data-v-69b2e8ae>¥10,368,294</td></tr><tr data-v-69b2e8ae><th scope=\"row\" data-v-69b2e8ae>7</th><td data-v-69b2e8ae>GGGG社</td><td data-v-69b2e8ae>¥18,301,067</td><td data-v-69b2e8ae>¥7,408,205</td><td data-v-69b2e8ae>¥10,892,861</td></tr><tr data-v-69b2e8ae><th scope=\"row\" data-v-69b2e8ae>8</th><td data-v-69b2e8ae>HHHH社</td><td data-v-69b2e8ae>¥14,762,161</td><td data-v-69b2e8ae>¥615,395</td><td data-v-69b2e8ae>¥14,146,766</td></tr><tr data-v-69b2e8ae><th scope=\"row\" data-v-69b2e8ae>9</th><td data-v-69b2e8ae>IIII社</td><td data-v-69b2e8ae>¥19,515,782</td><td data-v-69b2e8ae>¥2,683,425</td><td data-v-69b2e8ae>¥16,832,357</td></tr><tr data-v-69b2e8ae><th scope=\"row\" data-v-69b2e8ae>10</th><td data-v-69b2e8ae>JJJJ社</td><td data-v-69b2e8ae>¥18,691,567</td><td data-v-69b2e8ae>¥4,852,441</td><td data-v-69b2e8ae>¥13,839,126</td></tr></tbody></table></div>", 1)
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-lg-5" }
const _hoisted_23 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "構成割合"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_25 = { class: "panel-container show" }
const _hoisted_26 = { class: "panel-content border-faded border-left-0 border-right-0 border-top-0 text-muted d-flex" }
const _hoisted_27 = { class: "panel-content contents" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-xl-12" }
const _hoisted_30 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "対象案件一覧"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_32 = { class: "panel-container show" }
const _hoisted_33 = { class: "panel-content" }
const _hoisted_34 = {
  key: 0,
  class: "gtablecell btnDetCell"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-xs btn-block btn-primary waves-effect waves-themed"
}, " 詳細 ", -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 1,
  class: "gtablecell"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mo_chart_barline = _resolveComponent("Mo_chart_barline")!
  const _component_Mo_chart_doughnut = _resolveComponent("Mo_chart_doughnut")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_ctx.reRender)
                ? (_openBlock(), _createBlock(_component_Mo_chart_barline, {
                    key: 0,
                    chartData: _ctx.chartData4d2,
                    options: _ctx.chartOptions4d2
                  }, null, 8, ["chartData", "options"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              (_ctx.reRender)
                ? (_openBlock(), _createBlock(_component_Mo_chart_barline, {
                    key: 0,
                    chartData: _ctx.chartData4d10,
                    options: _ctx.chartOptions4d2
                  }, null, 8, ["chartData", "options"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  (_ctx.reRender)
                    ? (_openBlock(), _createBlock(_component_Mo_chart_barline, {
                        key: 0,
                        style: {"min-height":"500px"},
                        chartData: _ctx.chartData4d11,
                        options: _ctx.chartOptions4d11
                      }, null, 8, ["chartData", "options"]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_20
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_Mo_chart_doughnut, {
                style: {"width":"100%","max-height":"230px"},
                chartData: _ctx.chartData4d1,
                options: _ctx.chartOptions4d1
              }, null, 8, ["chartData", "options"])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_Mo_chart_doughnut, {
                style: {"width":"100%","max-height":"230px"},
                chartData: _ctx.chartData4d3,
                options: _ctx.chartOptions4d1
              }, null, 8, ["chartData", "options"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_vue_good_table, {
                columns: _ctx.columns,
                rows: _ctx.rows,
                "pagination-options": {
                  perPageDropdownEnabled: false,
                  enabled: true,
                  jumpFirstOrLast: true,
                  page: 1,
                  perPage: 20,
                  nextLabel: '次へ',
                  prevLabel: '前へ',
                  mode: 'pages',
                  ofLabel: '～',
                  pageLabel: '',
                },
                totalRows: _ctx.totalRecords
              }, {
                "table-row": _withCtx((props) => [
                  (props.column.field == '詳細ボタン')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
                    : (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(props.formattedRow[props.column.field]), 1))
                ]),
                _: 1
              }, 8, ["columns", "rows", "totalRows"])
            ])
          ])
        ])
      ])
    ])
  ]))
}